import axios from 'axios';
import { errorsInterceptor } from './interceptor';

const API_HEADERS = {};

API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';
API_HEADERS['Access-Control-Allow-Origin'] = true;

const API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: API_HEADERS,
  timeout: 10000,
  withCredentials: true,
});

errorsInterceptor(API);

export default API;
